import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


class Token {

  constructor(public access_token?: string, public expiration?: Date) {

  }
}


export interface User {

  firsNtame: string;
  lastname: string;
  phonenumber: string;
  lastConnection: Date;
  email: string;
  MSISDN: string;

}

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private token: Token;
  private timer: any;
  private user: any;
  private role: any;
  private LastConexion: any;
  private access: any;
  private lang: any;
  private expiration: any;
  constructor() {


    if (localStorage.getItem('token') != null)
      this.token = JSON.parse(localStorage.getItem('token'));

    if (localStorage.getItem('userRole') != null) {
      this.role = JSON.parse(localStorage.getItem('userRole'));
    }

  }

  setUser(infos: User) {
    localStorage.setItem('user', JSON.stringify(infos));
    this.user = infos;

  }

  getUser() {
    this.user = JSON.parse(localStorage.getItem('user'))
    return this.user;
  }
  setToken(token: Token, remember_me: boolean): any {
    if (remember_me) {
      localStorage.setItem('remembered', JSON.stringify(true));
    } else {
      localStorage.setItem('remembered', JSON.stringify(false));
    }
    localStorage.setItem('login_date', new Date().toISOString());
    localStorage.setItem('token', JSON.stringify(token));

    this.token = token;

  }
 

  getToken(): Token {
    return JSON.parse(localStorage.getItem('token'));
  }
  getRole(): any {
    this.role = localStorage.getItem('role')
    return this.role;
  }
  setRole(role: any): any {
    localStorage.setItem('role', role);
    this.role = role;
  }
  setPicture(picture: any): any {
    localStorage.setItem('picture', picture);
  }

  getLang(): any {
    this.lang = localStorage.getItem('lang')
    return this.lang;
  }
  setLang(lang: any): any {
    localStorage.setItem('lang', lang);
    this.lang = lang;
  }
  getLastConexion(): any {
    this.LastConexion = localStorage.getItem('LastConexion')
    return this.LastConexion;
  }
  setLastConexion(LastConexion: any): any {

    localStorage.setItem('LastConexion', LastConexion);
    this.LastConexion = LastConexion;
  }
  getAccess(): any {
    this.access = localStorage.getItem('access')
    return this.access;
  }
  setAccess(access: any): any {
    localStorage.setItem('access', JSON.stringify(access));
    this.access = access;
  }
  getExpirationDate(): any {
    this.expiration = localStorage.getItem('expiration')
    return this.expiration;
  }
  setExpirationDate(expiration: any): any {
    localStorage.setItem('expiration', expiration);
    this.expiration = expiration;
  }
  clear() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('login_date');
    localStorage.removeItem('organisation');
    localStorage.removeItem('role');
    localStorage.removeItem('access');
    localStorage.removeItem('LastConexion');
    localStorage.removeItem('expiration');
    localStorage.removeItem('subscriber');
    localStorage.removeItem('request');


  }
}
